export default "__VITE_ASSET__hMQbNQ_O__"